import Cookies from 'js-cookie';
import {
  Modal,
} from 'antd';

const isEmpty = (value) => {
  let result = false;
  if (value === '""' || value === '' || value === null || value === undefined) {
    result = true;
  }
  return result;
};

export const getLoginToken = () => {
  let loginToken = null;
  const NEWSSO = Cookies.get('T99BILLCOM_NEWSSO');
  const NEWSSOSECURE = Cookies.get('T99BILLCOM_NEWSSOSECURE');

  if (!isEmpty(NEWSSO)) {
    loginToken = NEWSSO;
  } if (!isEmpty(NEWSSOSECURE)) {
    loginToken = NEWSSOSECURE;
  }
  return loginToken;
};

export const delLoginToken = () => {
  Cookies.remove('T99BILLCOM_NEWSSO', { domain: '.99bill.com' });
  Cookies.remove('T99BILLCOM_NEWSSOSECURE', { domain: '.99bill.com' });
};

export const invalidTokenCode = '01'; // 登录失效errCode


export const handleExitToken = () => {
  delLoginToken();
  location.href = 'https://www.99bill.com/z/default.html';
};

export const handleInvalidToken = (errCode, errMsg) => {
  const errcode = errCode || '01';
  const errmsg = '您的登录状态已失效，请重新登录';

  Modal.confirm({
    zIndex: 1000,
    title: '账号异常',
    content: `${errmsg}`,
    okText: '重新登录',
    onOk() {
      handleExitToken();
    },
    cancelText: '刷新页面',
    onCancel() {
      location.reload();
    },
  });
};



// WEBPACK FOOTER //
// ./src/utils/LoginToken.js